import {SET_MESSAGE, CLEAR_MESSAGE} from "./types";
import RestService from "../services/rest.service";

export const fetchHomeDashBoard = () => (dispatch) => {

    const _ = require('lodash');
    const mockData = require("../../src/data/home_dashboard.json")
    const oData = mockData;
    // mapping data

    let aPaList = _.groupBy (oData, (loRow)=>( loRow.paId ))


    
    dispatch({
        type: "SET_HOME_DASHBOARD",
        payload: oData,
    });
    return Promise.resolve();
    // return RestService.get('Planning_CarryScore').then(
    //     (response) => {
    //         // mapping data
    //         dispatch({
    //             type: "SET_CARRY_SCORE",
    //             payload: response.data,
    //         });
    //         return Promise.resolve(response.data);
    //     },
    //     (error) => {
    //         const message =
    //             (error.response &&
    //                 error.response.data &&
    //                 error.response.data.message) ||
    //             error.message ||
    //             error.toString();
    //         dispatch({
    //             type: "REGISTER_FAIL",
    //         });
    //         dispatch({
    //             type: "SET_MESSAGE",
    //             payload: message,
    //         });
    //         return Promise.reject();
    //     }
    // );
};
